import { createSlice } from '@reduxjs/toolkit';
import { IGlobalSlice } from '@typings/rootSlice';

export const initialState: IGlobalSlice = {
    error: {},
    menuOpen: false,
    rightMenuOpen: false,
};

const globalSlice = createSlice({
    name: 'globalSlice',
    initialState,
    reducers: {
        setError(state, action) {
            state.error = action.payload;
        },
        clearError(state) {
            state.error = {};
        },
        setMenuOpen(state, action) {
            state.menuOpen = action.payload;
        },
        setRightMenuOpen(state, action) {
            state.rightMenuOpen = action.payload;
        },
    },
});

export const { setError, clearError, setMenuOpen, setRightMenuOpen } = globalSlice.actions;

export const globalActions = {
    setError,
    clearError,
    setMenuOpen,
    setRightMenuOpen,
};

export default globalSlice.reducer;
